<mat-card-content class="p-y-10" style="box-shadow: none;">
  <div class="row">
    <div class="col-sm-12">
      <mat-card-content>
        <ng-container *ngIf="isLoading; else categoryContent">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-container>

        <ng-template #categoryContent>
          <ng-container *ngIf="hasSubcategories">
            <app-opd-subcategory-panel
              *ngFor="let subcategory of unifiedSubcategories; let i = index; trackBy: trackBySubcategoryId"
              [subcategory]="subcategory"
              [category]="category"
              [items]="getItems(subcategory.id)"
              [checkedRecords]="checkedRecords"
              [panelId]="getPanelId(subcategory)"
              [expanded]="currentOpenPanel === getPanelId(subcategory)"
              [opdId]="opdId"
              (panelOpen)="handlePanelOpen($event)"
              (panelClose)="handlePanelClose($event)">
            </app-opd-subcategory-panel>
          </ng-container>
        </ng-template>
      </mat-card-content>
    </div>
  </div>
</mat-card-content>
